import { ApiErrorResponse } from '../models';
import i18n from './i18n';

/**
 * @param error The error object returned from the API.
 * @param translationPrefix The prefix for the translation keys.
 * @returns The translated error message
 */
export function getErrorMessageOnEntityCreateUpdate(
  error: any,
  translationPrefix: string,
) {
  const status = (error as ApiErrorResponse)?.status;
  let translationKey = `${translationPrefix}.error_generic`;

  if (status === 403) {
    translationKey = `${translationPrefix}.error_forbidden`;
  }

  if (status === 409) {
    translationKey = `${translationPrefix}.error_duplicate`;
  }

  return i18n.t(translationKey);
}
